import { render, staticRenderFns } from "./ReleaseLink.vue?vue&type=template&id=8dfb8758&scoped=true&"
import script from "./ReleaseLink.vue?vue&type=script&lang=ts&"
export * from "./ReleaseLink.vue?vue&type=script&lang=ts&"
import style0 from "./ReleaseLink.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ReleaseLink.vue?vue&type=style&index=1&id=8dfb8758&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dfb8758",
  null
  
)

export default component.exports